module.exports = __webpack_public_path__ + "img/creditcard_en.feffdbb5.svg";